import { environment } from "@shared/config/environment";
import { ENVConfigData } from "@shared/services/service-handlers/PublicService";
import { decrypt } from "@shared/utils/LocalStorage";

export const generateRandomString = length => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const generateSubModuleIdentifier = (module, sub_module, data) => {
  const {
    ID,
    specimen_number_id,
    procedure_id,
    procedure_type,
    demographic_id,
    row_id,
    patient_visit_id,
    sub_module_identifier_id
  } = data;
  if (sub_module_identifier_id?.length && data[sub_module_identifier_id]) {
    return data[sub_module_identifier_id];
  }

  if (module === 'surgical' && !(sub_module === 'demographics')) {
    if (row_id) {
      return row_id;
    }
    return patient_visit_id;
  }

  if (ID && (!module || !sub_module)) {
    return ID;
  }

  if (module === 'lis') {
    return specimen_number_id;
  }

  if (module === 'ris') {
    if (sub_module === 'exam_procedure_list') {
      return procedure_type ? procedure_id : demographic_id;
    } else {
      return demographic_id;
    }
  }
  return ID;
};

export const generateYearList = (startDate, endDate) => {
  const startYear = new Date(startDate).getFullYear();
  const endYear = new Date(endDate).getFullYear();
  const years = [];

  for (let year = startYear; year <= endYear; year++) {
    years.push(year.toString());
  }

  return years;
}

  export const fetchEnvironmentConfig = async () => {
    const response = await ENVConfigData();
    const decryptedData = decrypt(response?.data);
    try {
      const envData = JSON.parse(decryptedData);
      for (const key in envData) {
        if (Object.prototype.hasOwnProperty.call(envData, key)) {
          environment[key] = envData[key];
        }
      }
      return environment;
      // Your code to handle the parsed data
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
  };

